import router from "@/router";
import axios from 'axios';
import Vue from "vue";
const request = axios.create({
    // baseURL: 'http://120.27.140.243:9090',
    // timeout: 36000000
    // change to env based url
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 36000000,
    // headers: {
    //     'Content-Type': 'application/json'
    // },
    // Important for cookies/authentication
    withCredentials: true
})

const store = Vue.prototype.$store;

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    // config.headers['Content-Type'] = 'application/json;charset=utf-8';
    if(config.data instanceof FormData){
        delete config.headers['Content-Type']; // 让浏览器自动设置Content-Type为multipart/form-data
    } else {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null
    if (user) {
        console.log(user)
        if (user.role === 'teacher') {
            console.log(user.token)
            config.headers['teacher_token'] = user.token; // 设置教师请求头
        } else if (user.role === 'student') {
            config.headers['student_token'] = user.token; // 设置学生请求头
        } else {
            config.headers['manager_token'] = user.token; // 设置管理员请求头
        }
    }
    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.log('response错误验证....')
        console.log('err' + error) // for debug
        // 在这里进行全局错误处理，例如显示一个错误提示
        Vue.prototype.$notify.error({
            title: '错误',
            message: '验证失败，请重新登录'
        });
        // // 跳转至登录页面
        localStorage.clear()
        router.push('/login').catch(err => {});
        // 返回一个已经拒绝的Promise，中断Promise链
        return Promise.reject(error)
    }
)


export default request